module.exports = __webpack_public_path__ + "img/optionchain1.375169d9.png";